var _path, _path2, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoErasePen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1256 1.73005L16.7663 6.37076C17.4591 7.06358 17.4591 8.18686 16.7663 8.87969L14.9354 10.7105L10.4757 15.1702C10.1501 15.4959 9.71045 15.6823 9.25001 15.6898L7.08557 15.7251C6.60509 15.7329 6.14199 15.5455 5.80219 15.2057L4.54642 13.9499L2.22606 11.6295C1.53324 10.9367 1.53324 9.81344 2.22606 9.12062L7.78578 3.5609L9.61663 1.73005C10.3095 1.03723 11.4327 1.03723 12.1256 1.73005Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61663 1.73005C10.3095 1.03723 11.4327 1.03723 12.1256 1.73005L16.7663 6.37076C17.4591 7.06358 17.4591 8.18686 16.7663 8.87969L10.4757 15.1702C10.1501 15.4959 9.71045 15.6823 9.25001 15.6898L7.08557 15.7251C6.60509 15.7329 6.14199 15.5455 5.80219 15.2057L2.22606 11.6295C1.53324 10.9367 1.53324 9.81344 2.22606 9.12062L9.61663 1.73005ZM13.8748 10.357L9.76859 14.4631C9.62643 14.6053 9.4345 14.6866 9.23371 14.6899L7.06927 14.7252C6.85962 14.7286 6.65756 14.6468 6.5093 14.4986L2.93317 10.9224C2.63087 10.6201 2.63087 10.13 2.93317 9.82772L8.13934 4.62156L13.8748 10.357Z",
    fill: "#0C002C"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 15.3184,
    x2: 17,
    y2: 15.3184,
    stroke: "#0C002C",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoErasePen);
export default __webpack_public_path__ + "static/media/ico_erase_pen.65f4056dedf5f036322c2e4ae64d47e7.svg";
export { ForwardRef as ReactComponent };